import { validatePresence } from 'ember-changeset-validations/validators';

export default {
  name: validatePresence({ presence: true, message: 'Please enter a name' }),
};
